export default __webpack_public_path__ + "static/media/asideMobile.e8d53989.png";